export const styleBloco = { display: 'flex' }

export const styleButton = { display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', marginTop: '10px' }

export const styleObs = { width: '95%', height: '100px' }
